import { API } from "@/lib/api";
import { APIService } from "@/services/api";
import { ReadShiftReport, WriteShiftReport } from "@/types/shiftReport";

export const ShiftReportsService = new APIService<
  ReadShiftReport,
  WriteShiftReport
>(API.ShiftReports);
